export const PATIENT_KEY = "patient";

export const PATIENTS_KEY = "patients";

export const BALANCE_KEY = "patient-balance";

export const STATEMENT_KEY = "patient-statement";

export const DASHBOARD_KEY = "dashboard-summary";

export const CALENDAR_KEY = "appointments-calendar";

export const AVAILABILITY_KEY = "appointments-availability";

export const DOCTORS_KEY = "doctors";

export const USERS_KEY = "users";

export const WAITING_LIST_KEY = "waiting-list";

export const PENDING_BOOKINGS_KEY = "pending-bookings";

export const CONTACT_MESSAGES_KEY = "contact-messages";

export const WEBSITE_EDITOR_KEY = "website-editor";

export const PAYROLL_KEY = "payroll";

export const WHATSAPP_CHECK_KEY = "whatsapp-check";
export const PAYMENTS_KEY = "payments";

export const LAB_ORDERS_KEY = "lab-orders";
